import React from 'react';

// Content kept accurate to what this server actually has (verified against
// chatSystem.ts, professionService.ts, emoteService.ts, housingSystem.ts and
// identityService.ts) rather than copied from the reference mockup, which
// listed a couple of commands and keys that do not exist here.
const GUIDE = [
  {
    title: 'Métiers',
    text: "Choisis un métier et une spécialisation dans le menu des métiers (touche K). L'expérience gagnée débloque des rangs supérieurs et de nouvelles recettes.",
  },
  {
    title: 'Parler aux autres',
    text: 'Le roleplay se joue à la voix (touche V, en maintien). Le chat texte s\'ouvre avec Entrée, et /me et /do servent aux actions et aux descriptions.',
  },
  {
    title: 'Se présenter',
    text: "Tant qu'on ne t'a pas été présenté, un joueur apparaît comme un inconnu, et sa maison aussi. Vise-le avec ALT et choisis Se présenter.",
  },
  {
    title: 'Habiter',
    text: "Vise la porte d'un logement libre pour l'acheter ou la louer. Dans un fief, l'achat passe par l'approbation de l'Intendant. Le loyer est prélevé chaque semaine, avec trois jours de délai avant expulsion.",
  },
  {
    title: 'Gérer sa maison',
    text: 'Vise ta porte et fais ALT pour la verrouiller ou la déverrouiller, ou ouvrir la gestion du logement : clés, coffres, journal, vente. La commande /logement ouvre la même fenêtre.',
  },
  {
    title: 'Signalement',
    text: 'Un souci avec un joueur ou un bug ? Ouvre un ticket sur le Discord du serveur.',
  },
];

const KEYBINDS = [
  { key: 'Échap', label: 'Ce menu' },
  { key: 'V', label: 'Chat vocal (maintien)' },
  { key: 'Entrée', label: 'Ouvrir le chat' },
  { key: 'K', label: 'Menu des métiers' },
  { key: 'E', label: 'Interagir, activer' },
  { key: 'Alt', label: 'Menu contextuel : joueur, porte, coffre' },
];

const COMMANDS = [
  { cmd: '/logement', label: 'Gérer tes logements' },
  { cmd: '/accepterlogement', label: "Accepter l'offre de vente d'un logement" },
  { cmd: '/refuserlogement', label: "Refuser l'offre de vente d'un logement" },
];

const HelpPage: React.FC = () => {
  return (
    <div className="esc-help">
      <section className="esc-help__guide" aria-label="Mécaniques">
        {GUIDE.map((g) => (
          <article className="esc-card esc-guide" key={g.title}>
            <h3 className="esc-card__title">{g.title}</h3>
            <p className="esc-prose">{g.text}</p>
          </article>
        ))}
      </section>

      <aside className="esc-help__side">
        <section className="esc-card">
          <h3 className="esc-card__title">Touches</h3>
          <ul className="esc-keys">
            {KEYBINDS.map((k) => (
              <li className="esc-keys__row" key={k.label}>
                <kbd className="esc-kbd">{k.key}</kbd>
                <span>{k.label}</span>
              </li>
            ))}
          </ul>
        </section>

        <section className="esc-card">
          <h3 className="esc-card__title">Commandes</h3>
          <ul className="esc-keys">
            {COMMANDS.map((c) => (
              <li className="esc-keys__row esc-keys__row--stack" key={c.cmd}>
                <code className="esc-code">{c.cmd}</code>
                <span>{c.label}</span>
              </li>
            ))}
          </ul>
        </section>
      </aside>
    </div>
  );
};

export default HelpPage;
